import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import { rem } from "polished"
// import Link from "gatsby-link"
import { Row, Col } from "react-flexbox-grid"
import Container from "../components/container"
import { graphql } from "gatsby"
import InlineSVG from "react-inlinesvg"

import { UserContext } from "../components/global-context"

import SvgScale from "../components/svg-scale"

import { ReactComponent as Instagram } from "../assets/images/instagram.svg"
import { ReactComponent as Vimeo } from "../assets/images/vimeo.svg"

import LogoSpacer from "../components/logo-spacer"

const El = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;

  @media ${props => props.theme.mobileDown} {
    padding-bottom: ${rem(50)};
    padding-top: ${rem(70)};
  }
`

const StyledCol = styled(Col)``

const TopRow = styled(Row)`
  @media ${props => props.theme.mobileUp} {
    ${StyledCol} {
      &:nth-of-type(2) {
        margin-top: ${rem(100)};
      }

      &:nth-of-type(3) {
        margin-top: ${rem(200)};
      }
    }
  }

  @media ${props => props.theme.mobileDown} {
    ${StyledCol} {
      &:not(:first-of-type) {
        margin-top: ${rem(45)};
      }
    }
  }
`

const SocialsRow = styled(Row)`
  margin-top: ${rem(50)};
`

const InstagramCol = styled(Col)`
  @media ${props => props.theme.mobileDown} {
    order: 1;

    a {
      width: 33%;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: ${rem(25)};
    }
  }
`

const VimeoCol = styled(Col)`
  a {
    @media ${props => props.theme.mobileDown} {
      width: 20%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
`

const ContactPage = props => {
  const globalContext = useContext(UserContext)

  const data = props.data.wpPage.contactPageFields

  const footerData = props.data.wp.options.footer

  useEffect(() => {
    globalContext.setValue("#000")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <El>
      <Container>
        <LogoSpacer />

        <TopRow>
          {data.fields.map((item, index) => (
            <StyledCol
              key={index}
              lg={index === 1 ? 2 : 3}
              lgOffset={1}
              md={4}
              mdOffset={0}
              xs={8}
              xsOffset={2}
            >
              {item.link ? (
                <a href={item.link} rel="noreferrer" target="_blank">
                  <InlineSVG src={item.image.localFile.publicURL} />
                </a>
              ) : (
                <InlineSVG src={item.image.localFile.publicURL} />
              )}
            </StyledCol>
          ))}
        </TopRow>

        <SocialsRow>
          <InstagramCol lg={2} lgOffset={3} md={2} mdOffset={2}>
            {footerData.footerInstagramUrl && (
              <a
                href={footerData.footerInstagramUrl}
                rel="noreferrer"
                target="_blank"
              >
                <SvgScale width={78} mobile={100}>
                  <Instagram />
                </SvgScale>
              </a>
            )}
          </InstagramCol>

          <VimeoCol lg={1} md={1}>
            {footerData.footerVimeoUrl && (
              <a
                href={footerData.footerVimeoUrl}
                rel="noreferrer"
                target="_blank"
              >
                <SvgScale width={100} mobile={100}>
                  <Vimeo />
                </SvgScale>
              </a>
            )}
          </VimeoCol>
        </SocialsRow>
      </Container>
    </El>
  )
}

export const query = graphql`
  query ContactPageQuery {
    wpPage(id: { eq: "cG9zdDo1OQ==" }) {
      title
      contactPageFields {
        fields {
          link
          image {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    wp {
      options {
        footer {
          footerInstagramUrl
          footerVimeoUrl
        }
      }
    }
  }
`

export default ContactPage
